import React from "react";
import { useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import chevronLeft from "@iconify/icons-mdi/chevron-left";
import { InlineIcon } from "@iconify/react";

interface OcPageNameTitleProps {
  title: string;
  goBack?: boolean;
}

export const OcPageNameTitle = ({ title, goBack }: OcPageNameTitleProps) => {
  const theme = useTheme();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      padding="16px"
    >
      <Box display="flex" alignItems="center">
        {goBack && (
          <Box>
            <InlineIcon
              id="go-back"
              icon={chevronLeft}
              width="32px"
              color={"#5E6366"}
              style={{
                cursor: "pointer",
                marginRight: "10px",
                marginTop: "5px",
              }}
              onClick={handleGoBack}
            />
          </Box>
        )}
        <Typography
          variant="h4"
          style={{
            color: theme.palette.gray80.main,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default OcPageNameTitle;
